import { XCircle } from 'lucide-react';

export function CampaignCancelledIcon({ className }: { className?: string }) {
  return <XCircle className={className} />;
}
